import type { DialogProps } from "../misc/DialogProps";
import { Dialog, DialogContent } from "@mui/material";
import { DialogCloseButton } from "../misc/DialogCloseButton";
import { PrepaidInvoicesCard } from "../details/student/PrepaidInvoicesCard";
import { useRecordContext } from "react-admin";
import { Student } from "../providers/studentsProvider";
import React from "react";

export function PrepaidCreditsDialog(props: DialogProps) {
  const student = useRecordContext<Student>();
  return (
    <Dialog {...props} maxWidth="md" fullWidth>
      <DialogCloseButton onClick={props.onClose} />
      <DialogContent>
        <PrepaidInvoicesCard studentId={student.id} />
      </DialogContent>
    </Dialog>
  );
}
